const changeMakersData = [
    {
        img: '/Images/changemaker1.jpg',
        name: ' Sandeep Sahu, Co-Founder, Director',
        content: "When I first trekked through Ladakh in the early '80s, the beauty of the Himalayas was overshadowed by the stark isolation and lack of opportunities for its people. Each subsequent trek revealed the same story—a region rich in heritage but struggling with the basics of education. And so 17000ft Foundation was born in 2012 with a mission to strengthen India's vulnerable border regions by addressing the root cause of migration: Education.",
        icon: 'ti-arrow-right',
        linkTitle: "Read More",
        name1:'17000 ft Foundation',
        link:'/GSN-5027/17000ft',
        id:'Causes'
    },
    {
        img: '/Images/changemaker2.webp',
        name: 'Shaheen Malik, Founder',
        content: 'At just 26, my life was shattered when someone hurled acid at me — burning 90% of my face and body. The pain was unbearable, like needles piercing every inch of my skin. Recovery wasn’t just physical; it was a battle for my identity and spirit. In 2021, I turned my pain into purpose by founding Brave Souls Foundation — to offer the help I once needed but couldn’t find.',
        icon: 'ti-arrow-right',
        linkTitle: "Read More",
        name1:'Brave Souls Foundation ',
        link:'/GSN-14113/BSF-India',
        id:'Causes'
    },
    {
        img: '/Images/changemaker3.png',
        name: 'Indraneel Roy, Administration Manager',
        content: 'My love for animals sparked in 2016 while volunteering at Thane CPCA animal hospital. Witnessing their silent suffering and total dependence on human kindness, especially in cities, changed me forever. That experience lit a fire in me — a lifelong mission to be their voice. My dream is to transform Thane CPCA into a world-class facility where no animal is denied treatment due to financial constraints.',
        icon: 'ti-arrow-right',
        linkTitle: "Read More",
        name1:'Thane Community for the Protection and Care of Animals',
        link:'/GSN-1894/ThaneCPCA',
        id:'Operations'
    },
]
export { changeMakersData }